export const unitListing = (state, id) => state?.entities?.unitListing?.[id];
export const unitListings = (state) => state?.entities?.unitListing;
